import { FC } from 'react';
import { createPortal } from 'react-dom';

import Modal from '@z-components/atoms/Modal';
import { AvailablePrefecture } from '@z-components/molecules/types';

import styles from './PrefectureDetailModal.module.scss';

const TRANSLATIONS = {
  en: {
    availableArea: ' Available Area',
  },
  ja: {
    availableArea: 'の対応可能エリア',
  },
};

interface Props {
  prefecture: AvailablePrefecture;
  handleModalDismiss: () => void;
  language: 'en' | 'ja';
}

const PrefectureDetailModal: FC<Props> = ({ prefecture, handleModalDismiss, language }) =>
  createPortal(
    <Modal
      modalName="prefecture-detail"
      onDismiss={handleModalDismiss}
      closeButtonVariant={'gray'}
      isModalRounded={true}
    >
      <div className={styles.wrapper}>
        <h3 className={styles.title}>
          {prefecture.name}
          {TRANSLATIONS[language].availableArea}
        </h3>
        <ul className={styles.list}>
          {prefecture.cityGroups?.map((cityGroup) => (
            <li key={cityGroup.id} className={styles['city-group-list']}>
              <h4 className={styles['city-group-title']}>{cityGroup.name}</h4>
              <ul className={styles['city-list']}>
                {cityGroup.cities.map((city) => (
                  <li className={styles['city-name']} key={city.id}>
                    {city.name}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
    </Modal>,
    document.body
  );

export default PrefectureDetailModal;
